import { useEffect, useState } from "react";
import Select from 'react-select';
import DayJS from 'react-dayjs';
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import setDate from "date-fns/set";
import StyledCard from 'components/StyledCard';
import useAuth from "../../hooks/useAuth";
import useUser from "../../hooks/useUser";
import useAPI from "../../hooks/useAPI";
import useDb from "../../hooks/useDb";
import PageLayout from "components/PageLayout";
import BackButton from "components/BackButton";
import { useHistory } from "react-router-dom";
import useStyles from './styles';
import { getPersonName } from 'utils/helper';

const Manage = () => {
  const history = useHistory();
  const [appointments, setAppointments] = useState([]);
  const [users, setUsers] = useState([])
  const [technician, setTechnician] = useState();
  const { user } = useUser();
  const api = useAPI();
  const db = useDb();
  const styles = useStyles()

  useEffect(() => {
    if (user.role !== "tech.admin") history.push("/app")
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  useEffect(() => {
    getAppointmentByTechnician(user._id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    api
    .get('/users')
    .then(res => {
      setUsers(
        res.data.users
        .filter(user => user.role.includes('tech.'))
        .map(user => ({ label: getPersonName(user), value: user._id }))
        )
      setTechnician({ label: getPersonName(user), value: user._id })
    })
    .catch(err => console.log(err))
    // eslint-disable-next-line
  }, [])

  console.log("appointments", appointments);

  const getAppointmentByTechnician = (technicianId) => {
    api
      .get(`/technicians/${technicianId}/appointments`, {
        params: {
          start: setDate(new Date(), {
            hours: 0,
            minutes: 0,
            seconds: 0,
            milliseconds: 0,
          })
        },
      })
      .then(async (res) => {
        await db.appointments.bulkAdd(
          res.data.appointments.map((appt) => ({ ...appt, pictures: [] }))
        );
      })
      .catch((err) => {
        if (err.name === "BulkError") {
          console.log("ignore dupe keys");
        } else {
          console.log(err);
        }
      })
      .finally(async () => {
        const _appointments = await db.appointments
          .filter((appt) => !appt.completed && appt.technician._id === technicianId)
          .toArray();
        setAppointments(_appointments);
      });

  }

  const onChangeTechnicianFilter = (value) => {
    setTechnician(value);
    if (value && value.value) getAppointmentByTechnician(value.value);
  }

  const reassignJob = (appointment) => {
    history.push(`/reassign/${appointment._id}`)
  }

  return (
    <PageLayout title="Manage Jobs">
      <Container maxWidth="md">
        <Box display="flex" mt={3} alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center">
            <Typography>Select a tech to display the jobs for</Typography>
            <Box width={200} ml={2}>
              <Select
                placeholder="Technician"
                options={users}
                width={250}
                value={technician}
                onChange={ onChangeTechnicianFilter }
                menuPortalTarget={document.body} 
                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                />
            </Box>
          </Box>
          <BackButton url='/' />
        </Box>
        {appointments.map((appt) => (
          <StyledCard variant="outlined" key={appt._id}>
            <Box display="flex">
              <Box flex={1}>
                <Typography variant="h6" className={styles.subheading}>Customer Information:</Typography>
                <Typography className={styles.paragraph}>{`${appt.customer.firstName} ${appt.customer.middleName} ${appt.customer.lastName}`}</Typography>
                <Typography className={styles.paragraph}>{`${appt.customer.streetNumber} ${appt.customer.streetName}`} {appt.customer.unit ? `UNIT ${appt.customer.unit}` : ''}</Typography>
                <Typography className={styles.paragraph}>{`${appt.customer.city}, ${appt.customer.primaryPhone}`}</Typography>
                <Typography className={styles.paragraph}>Enrollment #: { appt.customer.enrollment?.enrollmentNumber }</Typography>
              </Box>
              <Box flex={1}>
                <Box mb={2}>
                  <Typography variant="h6" className={styles.subheading}>Time and Date:</Typography>
                  <Typography className={styles.paragraph}><DayJS format="MM/DD/YYYY">{ appt.start }</DayJS></Typography>
                  <Typography className={styles.paragraph}><DayJS format="hh:mm a">{ appt.start }</DayJS></Typography>
                </Box>
                <Box mb={2}>
                  <Typography variant="h6" className={styles.subheading}>Technician:</Typography>
                  <Typography className={styles.paragraph}>{ getPersonName(appt.technician) }</Typography>
                </Box>
              </Box>
            </Box>
            <Button className={styles.viewButton} variant="contained" color="primary" onClick={() => reassignJob(appt)}>
              Edit
            </Button>
          </StyledCard>
        ))}
      </Container>
    </PageLayout>
  );
};

const Page = () => {
  const { PrivateContent } = useAuth();
  return (
    <PrivateContent title="Manage Jobs">
      <Manage />
    </PrivateContent>
  );
};

export default Page;
